import { gql } from "apollo-boost";

export const GET_REVIEW = gql`
  query reviews($filters: ReviewInput) {
    reviews(filters: $filters) {
    reviews{
    id,
    reviewer
    reviewerName
    reviewee
    rating
    bookingId
    tags
    body
    reviewType
    updatedAt
    createdAt
    }
    }
  }
`;

export const GET_BOOKING_USER_REVIEW = gql`
  query getReviewByBookingIdForUser($bookingId: ID!, $userId: ID!) {
    getReviewByBookingIdForUser(bookingId: $bookingId, userId: $userId) {
      id,
      reviewer
      reviewerName
      reviewee
      rating
      bookingId
      tags
      body
      reviewType
      updatedAt
      createdAt
    }
  }
`;

